import React, {Component} from 'react';

export default class SuccessPopup extends Component {
    render() {
        return (
            <div data-text="Информация" className="ticket">
                <h5 className="text-accent">Вы записаны на медицинский осмотр в "Городской Центр Медосмотра" <span
                    className="tag tag-success">{this.props.data.date}</span> начало оформления в <span
                    className="tag tag-success">{this.props.data.time}</span>.</h5>
                <p className="align-left text-accent">
                    Ознакомьтесь, пожалуйста, с <a href="https://gormedosmotr.ru/patients/">памяткой</a> для прохождения медосмотра.
                </p>
                <button className="button button-success" onClick={this.props.closeHandler}><i
                    className="fa fa-check"></i> На главную
                </button>

                <div style={{
                    paddingTop: '20px',
                    display: 'flex',
                    alignItems: 'center'
                }}>
                    <div style={{maxWidth:"500px"}} className="left">
                        <b>Будьте на связи с МАКС-ботом</b>
                        <p>
                            Получайте уведомления о записях, результатах анализов и важных новостях клиники. Это быстро, удобно и бесплатно
                        </p>
                        <a href="https://max.ru/id5402556132_bot" style={{
                            display: 'inline-block',
                            padding: '10px 20px',
                            background: '#457cf0',
                            color: '#fff'
                        }}>Запустить бота</a>
                    </div>
                    <div className="right">
                        <img style={{maxWidth:"200px"}} src="/assets/images/qr.png" />
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// frontend/src/modules/AppointmentForm/SuccessPopup.js